var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 95"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#success_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39CE64",
    d: "M48 94.33c25.864 0 46.83-20.966 46.83-46.83C94.83 21.636 73.865.669 48 .669c-25.864 0-46.831 20.967-46.831 46.83 0 25.865 20.967 46.832 46.83 46.832Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0",
    d: "M48 1.338c25.45 0 46.162 20.713 46.162 46.162 0 25.45-20.713 46.162-46.162 46.162-25.45 0-46.162-20.713-46.162-46.162C1.838 22.05 22.551 1.338 48 1.338ZM48 0C21.761 0 .5 21.261.5 47.5S21.761 95 48 95s47.5-21.261 47.5-47.5S74.239 0 48 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0F0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "m36.961 72.535-3.92-3.961L15.647 51.18l9.981-8.524 12.444 11.869 32.567-32.06 9.715 11.44-43.393 38.63Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "success_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h95v95H.5z"
  })))));
};
export default SvgSuccess;